// submitShipping.ts — method ongkir + rincian subsidi untuk payload order
import type { Form } from '../../../../types';
import { getEffectiveMaxSubsidy } from '../../../../utils/shippingSubsidy';

export interface ShippingFields { shipMethod: string; everproFull: number; discount: number; }

// Subsidi gratis-ongkir-maks → method 'everpro (subsidi)' supaya guard isOngkirMissing
// backend mengenalinya sebagai ongkir terhitung (termasuk saat bayar 0 karena tarif < maks).
export function buildShippingFields(form: Form | null, selectedEverproRate: any, selectedBiteshipRate: any, selectedShippingKey: any, selectedPaymentKey: any, herbalSubsidy: number, discountAmount: number | undefined, currentCombination?: { maxSubsidy?: number | null; attributes?: Record<string, string> } | null, quantity?: number | null): ShippingFields {
  const maks = getEffectiveMaxSubsidy(form, currentCombination ?? null, quantity ?? 1);
  const shipMethod: string = selectedEverproRate
    ? ((form?.shippingSettings?.free?.visible && !form?.shippingSettings?.regular?.visible && maks > 0) ? 'everpro (subsidi)' : 'everpro')
    : selectedBiteshipRate ? 'biteship' : (herbalSubsidy > 0 ? 'everpro (subsidi)' : String(selectedShippingKey || selectedPaymentKey || ''));
  // Rincian subsidi untuk kolom detail: tarif penuh Everpro + potongan.
  // Non-subsidi: full = bayar, subsidi = 0.
  const everproFull = (selectedEverproRate as any)?.price || 0;
  const discount = Math.max(0, Math.round(Number(discountAmount) || 0));
  return { shipMethod, everproFull, discount };
}
